<script setup lang="ts">
import {ConsumerProduct} from "@/consumer/interfaces";
import {computed} from "vue";
import TrackerLayout from "@/interview/components/instance-modal/consumer-product-tracking/trackers/TrackerLayout.vue";
import dateHelper from "@/core/helpers/dateHelper";
import {Button} from "@/core/components/ui/button";

const props = defineProps<{
    consumerProducts: ConsumerProduct[];
    consumerKey: string;
}>();
const emits = defineEmits<{
    (e: 'openDosageDialog'): void
}>();

const done = computed(() => {
    return props.consumerProducts.every((consumerProduct: ConsumerProduct) => {
        return !!consumerProduct.product.latest_dosage;
    });
});

const latestDosage = computed(() => {
    const dosages = props.consumerProducts
        .map((consumerProduct: ConsumerProduct) => consumerProduct.product.latest_dosage)
        .filter(dosage => !!dosage);

    if (dosages.length === 0) {
        return null;
    }

    dosages.sort((a, b) => {
        return new Date(b!.created_at).getTime() - new Date(a!.created_at).getTime();
    });

    return dosages[0];
});
</script>

<template>
  <TrackerLayout :state="done ? 'done' : 'to-do'" title="Posologie">
    <template v-if="latestDosage" #latest>
      Dernière révision le {{ dateHelper.shortFormat(latestDosage.created_at) }}
    </template>
    <template #action>
      <Button
        variant="ghost"
        size="xs"
        class="text-primary"
        @click="emits('openDosageDialog')"
      >
        Lancer le pilulier
      </Button>
    </template>
  </TrackerLayout>
</template>

<style scoped>

</style>
